import { ISolicitacaoAtivacao } from "../../../interfaces";

import TabCheckIcon from "../TabCheckIcon";

interface IProps {
    solicitacao: ISolicitacaoAtivacao | null;
    numeroEtapa: number;
    descricaoEtapa: string;
}

export default function EtapaTabTitle({
    solicitacao,
    descricaoEtapa,
    numeroEtapa,
}: IProps) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
            }}
        >
            <span>{numeroEtapa} - {descricaoEtapa}</span>

            <TabCheckIcon
                solicitacao={solicitacao}
                etapaOrdem={numeroEtapa}
            />
        </div>
    )
}
